<template>
  <div>
    <TreatmentFilter
      v-if="$can('filter', 'treatments')"
      :loading="loading"
      @searchFilter="searchFilter"
      @filterPage="filterPage"
    />
    <b-card>
      <TitleTable titleTable="Treatments" iconTable="fas fa-disease" />
      <div class="m-1">
        <TreatmentEdit
          v-if="isEditTreatmentSidebarActive"
          :is-edit-treatment-sidebar-active.sync="isEditTreatmentSidebarActive"
          :itemEdit="itemEdit"
          :itemsCategories="itemsCategories"
          @editTreatmentSuccess="editTreatmentSuccess"
        />
        <TreatmentAdd
          v-if="isAddNewTreatmentSidebarActive"
          :is-add-new-treatment-sidebar-active.sync="
            isAddNewTreatmentSidebarActive
          "
          :itemsCategories="itemsCategories"
          @createTreatment="createTreatment"
        />
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <treeselect
              v-model="perPage"
              :options="perPageOptions"
              :clearable="true"
              class="w-25"
            />
          </b-col>
          <!-- {{ $t("Search") }} -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <GoBack class="mr-2" />
              <b-button
                v-if="$can('store', 'treatments')"
                variant="primary"
                @click="isAddNewTreatmentSidebarActive = true"
                :disabled="loading"
              >
                <span v-if="!loading" class="text-nowrap"
                  >{{ $t("Add") }} Treatment</span
                >
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        hover
        bordered
        responsive
        primary-key="id"
        class="position-relative min-height-table"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(status)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.status ? $t("Active") : $t("Inactive")
            }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="canEditTreatment(data.item)"
            variant="outline-primary"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Edit'"
            @click="editTreatment(data.item)"
          >
            <i class="fas fa-pen icon-nm"></i>
          </b-button>

          <b-button
            v-if="$can('destroy', 'treatments') && data.item.is_iv_serum_marker !== true"
            variant="outline-danger"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Delete'"
            @click="deleteTreatment(data.item)"
          >
            <i class="fas fa-trash-alt icon-nm"></i>
          </b-button>
        </template>
      </b-table>
      <PaginationTable
        :dataMeta="dataMeta"
        :totalUsers="totalUsers"
        :perPage="perPage"
        :currentPage="currentPage"
        @page-changed="pageChanged"
      />
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import axiosAC from "@/core/services/api/admin/consults/treatments";
import axiosACT from "@/core/services/api/admin/consults/treatmentCategories";

import ToastNotification from "@/components/ToastNotification";
import SpinnerLoading from "@/components/SpinnerLoading";
import PaginationTable from "@/components/PaginationTable";
import TitleTable from "@/components/TitleTable.vue";
import GoBack from "@/components/ButtonBack.vue";
import Swal from "sweetalert2";

import TreatmentEdit from "./TreatmentEdit.vue";
import TreatmentAdd from "./TreatmentAdd.vue";
import TreatmentFilter from "./TreatmentFilter.vue";
import { ref } from "@vue/composition-api";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BAvatar,
    BButton,
    TreatmentEdit,
    TreatmentAdd,
    TreatmentFilter,
    ToastNotification,
    SpinnerLoading,
    PaginationTable,
    TitleTable,
    GoBack,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "id",
        { key: "name", label: "Name", sortable: true },
        { key: "cat_treatments.name", label: "Category", sortable: true },
        'price_cost',
        { key: "price", label: "Price", sortable: true },
        { key: "dosificacion", label: "Dosificacion", sortable: true },
        { key: "unit", label: "Unit", sortable: true },
        { key: "value_per_unit", label: "Value per unit", sortable: true },
        { key: "informed_consent", sortable: true },
        { key: "status", label: "Status" },
        // A virtual column made up from two fields
        { key: "actions", label: "Actions" },
      ],
      items: null,
      itemsCategories: [],
      loading: false,
      isEditTreatmentSidebarActive: false,
      isAddNewTreatmentSidebarActive: false,
      itemEdit: null,
      dataMeta: { from: 1, to: 1, of: 1 },
      totalUsers: 0,
      perPage: 10,
      currentPage: {
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100].map((i) => ({
        id: i,
        label: `Show ${i} Entries`,
      })),
      filtro: false,
      treatmentFilter: null,
    };
  },
  mounted() {
    this.getTreatment();
    axiosACT.treatmentCategoryList(this.perPage).then(({ data }) => {
      this.itemsCategories = data
    });
  },
  watch: {
    perPage(newVal) {
      if (!this.filtro) {
        this.getTreatment();
      } else {
        this.searchFilter(this.treatmentFilter);
      }
    },
  },
  methods: {
    /** El treatment que identifica a los sueros IV solo lo editan admin y superadmin. */
    canEditTreatment(item) {
      if (!this.$can("update", "treatments")) return false;
      if (item?.is_iv_serum_marker !== true) return true;
      if (this.$can("manage", "all")) return true;
      const roles = JSON.parse(localStorage.getItem("userData") || "{}").roles || [];
      return roles.some((role) => String(role?.name || "").toLowerCase() === "admin");
    },
    getTreatment() {
      axiosAC
        .treatmentList(this.perPage)
        .then(({ data, current_page, total, per_page, ...res }) => {
          this.items = data;
          this.totalUsers = total;
          this.dataMeta.of = total;
          this.dataMeta.from = res.from;
          this.dataMeta.to = res.to;
          this.currentPage.page = current_page;
        });
    },
    editTreatment(item) {
      this.isEditTreatmentSidebarActive = true;
      this.itemEdit = ref(JSON.parse(JSON.stringify(item)));
    },
    editTreatmentSuccess(value) {
      if (value) {
        this.$refs.toast.success("Type Treatment updated successfully");
      } else {
        this.$refs.toast.error("Error updating type treatment");
      }
      this.isEditTreatmentSidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    createTreatment({ status }) {
      if (status) {
        this.$refs.toast.success("Treatment type added successfully");
      } else {
        this.$refs.toast.danger("Treatment type not added");
      }
      this.isAddNewTreatmentSidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    deleteTreatment(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosAC.treatmentDelete(item.id).then((response) => {
            this.$refs.toast.success(
              "Treatment type has been deleted successfully"
            );
            this.pageChanged(this.currentPage.page);
          });
        }
      });
    },
    pageChanged(page) {
      if (!this.filtro) {
        axiosAC
          .treatmentPagination(this.perPage, page)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      } else {
        axiosAC
          .treatmentFilterPagination(this.perPage, page, this.treatmentFilter)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      }
    },
    searchFilter(value) {
      if (this.filtro) {
        this.loading = true;
        this.treatmentFilter = value;
        axiosAC
          .treatmentFilter(this.perPage, value)
          .then(({ data, total, current_page, ...res }) => {
            this.loading = false;
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.getTreatment();
      }
    },
    filterPage(value) {
      this.filtro = value;
    },
  },
};
</script>

<style></style>
